import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ItemService } from './../../services/item.service';
import { Spot } from '../../models/Item';
import { Chart } from 'chart.js';


@Component({
  selector: 'app-missing-report',
  templateUrl: './missing-report.component.html',
  styleUrls: ['./missing-report.component.css']
})
export class MissingReportComponent implements OnInit {


  constructor(public itemService: ItemService, public router: Router) { }

  CompOne = '';
  CompTwo = '';
  CompThree = '';
  CompFour = '';
  primary = '';


  chart = [];

  // public data: any[];
  // dateSelected: any;
  public daterange: any = {};
  public advertiser: any;
  public options: any = {
    locale: { format: 'MM/DD/YYYY' },

    alwaysShowCalendars: false,
    startDate: this.itemService.sd,
    endDate: this.itemService.ed,
    minDate: '01/01/2017',
    // maxDate: '31/03/2017',
    opens: 'left',
    showWeekNumbers: true,
    ranges: {
      // 'Yesterday': [
      //     '2018-02-26T07:00:33.456Z',
      //     '2018-02-26T07:00:33.456Z'
      // ],
      'Last 7 Days': [
        '01/01/2017',
        '01/07/2017'
      ],
      'Last 30 Days': [
        '01/01/2017',
        '01/30/2017'
      ],
      'This Month': [
        '01/01/2017',
        '01/31/2017'
      ],
      'Last Month': [
        '01/01/2017',
        '01/31/2017'
      ]
    },
  };



  public selectedDate(value: any, datepicker?: any) {
    this.itemService.showSpinner = true;


    datepicker.start = value.start;
    datepicker.end = value.end;

    // or manupulat your own internal property
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;

    let start;
    let end;
    start = new Date(this.daterange.start);
    end = new Date(this.daterange.end);

    // start Date Function
    const sd_date = ('0' + start.getDate()).slice(-2);
    const sd_Month = ('0' + (start.getMonth() + 1)).slice(-2);
    const sd_year = start.getFullYear();

    const startDate = ((sd_Month) + '-' + sd_date + '-' + sd_year);
    this.itemService.startDate = start;
    // console.log(this.itemService.startDate);

    // end Date Function
    const ed_date = ('0' + end.getDate()).slice(-2);
    const ed_Month = ('0' + (end.getMonth() + 1)).slice(-2);
    const ed_year = end.getFullYear();

    const endDate = ((ed_Month) + '-' + ed_date + '-' + ed_year);
    this.itemService.endDate = end;
    // console.log(this.itemService.endDate);

    // dateChanged Function

    this.itemService.startDateTemp = new Date(startDate)
    this.itemService.endDateTemp = new Date(endDate)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;



    let advertiserSelected = this.itemService.selected_adv ? this.itemService.selected_adv : 'Not Selected';
    let parameters: any = {
      section_name: 'Publishers',
      page_name: 'Advertisers',
      advertiser: advertiserSelected,
      startDate: this.itemService.startDate,
      days: this.itemService.days,
      endDate: this.itemService.endDate,
    }
    this.itemService.logEvent('onDateChange', parameters);

    this.itemService.selected_primaryChannel = null;
    this.itemService.missingAdvertisers_ComOne = null;
    this.itemService.missingAdvertisers_ComTwo = null;
    this.itemService.missingAdvertisers_ComThree = null;
    this.itemService.missingAdvertisers_ComFour = null;
    this.CompOne = '';
    this.CompTwo = '';
    this.CompThree = '';
    this.CompFour = '';
    this.primary = '';


    this.itemService.showSpinner = false;
    this.itemService.dateChangeDetector();
  }


  onChangePrimary(value, type) {

    this.itemService.missingAdvertisers_ComOne = null;
    this.itemService.missingAdvertisers_ComTwo = null;
    this.itemService.missingAdvertisers_ComThree = null;
    this.itemService.missingAdvertisers_ComFour = null;
    this.itemService.selected_CompOne = null;
    this.itemService.selected_CompTwo = null;
    this.itemService.selected_CompThree = null;
    this.itemService.selected_CompFour = null;
    this.CompOne = '';
    this.CompTwo = '';
    this.CompThree = '';
    this.CompFour = '';

    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    let parameters: any = {
      section_name: 'Publishers',
      page_name: 'Missing Report',
      advertiser: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_primaryChannel = value;
    this.itemService.fetchPulisher = value;
    this.itemService.fetchPulisherType = type;
    // this.itemService.fetchPublishers(value, type);
    this.itemService.checkQuota();
    
  }

  onChangeCompOne(value, type) {
    this.itemService.missingAdvertisers_ComOne = null;

    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    let parameters: any = {
      section_name: 'Publishers',
      page_name: 'Missing Report',
      advertiser: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_CompOne = value;
    this.itemService.fetchPulisher = value;
    this.itemService.fetchPulisherType = type;
    // this.itemService.fetchPublishers(value, type);
    this.itemService.checkQuota();

  }

  onChangeCompTwo(value, type) {
    this.itemService.missingAdvertisers_ComTwo = null;

    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    let parameters: any = {
      section_name: 'Publishers',
      page_name: 'Missing Report',
      advertiser: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_CompTwo = value;
    this.itemService.fetchPulisher = value;
    this.itemService.fetchPulisherType = type;
    // this.itemService.fetchPublishers(value, type);
    this.itemService.checkQuota();
    
  }

  onChangeCompThree(value, type) {
    this.itemService.missingAdvertisers_ComThree = null;

    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    let parameters: any = {
      section_name: 'Publishers',
      page_name: 'Missing Report',
      advertiser: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_CompThree = value;
    this.itemService.fetchPulisher = value;
    this.itemService.fetchPulisherType = type;
    // this.itemService.fetchPublishers(value, type);
    this.itemService.checkQuota();
    
  }

  onChangeCompFour(value, type) {
    this.itemService.missingAdvertisers_ComFour = null;
    this.itemService.startDateTemp = new Date(this.itemService.sd)
    this.itemService.endDateTemp = new Date(this.itemService.ed)
    this.itemService.days = Math.round(Math.abs((this.itemService.startDateTemp.getTime() - this.itemService.endDateTemp.getTime()) / (24 * 60 * 60 * 1000))) + 1;

    let parameters: any = {
      section_name: 'Publishers',
      page_name: 'Missing Report',
      advertiser: value,
      startDate: this.itemService.startDateTemp,
      days: this.itemService.days,
      endDate: this.itemService.endDateTemp,
    }
    this.itemService.logEvent('onAdvertiserChange', parameters);

    this.itemService.selected_CompFour = value;
    this.itemService.fetchPulisher = value;
    this.itemService.fetchPulisherType = type;
    // this.itemService.fetchPublishers(value, type);
    this.itemService.checkQuota();
    
  }






  ngOnInit() {
    this.itemService.missingAdvertisers_ComOne = null;
    this.itemService.missingAdvertisers_ComTwo = null;
    this.itemService.missingAdvertisers_ComThree = null;
    this.itemService.missingAdvertisers_ComFour = null;
    this.itemService.selected_CompOne = null;
    this.itemService.selected_CompTwo = null;
    this.itemService.selected_CompThree = null;
    this.itemService.selected_CompFour = null;
    this.CompOne = '';
    this.CompTwo = '';
    this.CompThree = '';
    this.CompFour = '';
    this.primary = '';

    let parameters: any = { section_name: 'Publishers', page_name: 'Missing Reports' }
    this.itemService.logEvent('onPageView', parameters);

    this.itemService.secondary_selected_adv = null;
    this.itemService.secondary_selected_adv_brand = null;
    this.itemService.selected_adv_brand = null;
    this.itemService.selected_adv_channel = null;
    this.itemService.selected_cat = null;

    // this.itemService.showSpinner = true;
    this.itemService.url = this.router.url;

    // this.itemService.dateChangeDetector();
  }

}


// WEBPACK FOOTER //
// ./src/app/publishers/missing-report/missing-report.component.ts